var obj=[
"",
"健身设施",
"赠送欢迎水果",
"免费礼品",
"免费赠送鲜花",
"收费提供接送机",
"免费提供接送机",
"免费游泳池",
"免费穿梭巴士",
"免费停车场",
"免费拨打市话",
"免费拨打国内长途",
"收费电视",
"保险箱",
"熨斗",
"DVD机",
"语音留言",
"电脑",
"电热水壶",
"中央空调",
"分体式空调",
"冰箱",
"房间内高速上网",
"收费传真服务",
"吹风机",
"CD机",
"卫星电视",
"电视",
"",
"供暖设施",
"中餐厅",
"客房送餐服务",
"宴会厅",
"室外花园",
"租车服务",
"外币兑换",
"花店",
"儿童游乐设施",
"咖啡厅",
"洗衣服务",
"ATM机",
"商店",
"夜总会",
"便利店",
"乒乓球室",
"商务中心",
"酒吧",
"体育馆",
"叫醒服务",
"烧烤用庭院",
"网球场",
"歌舞厅",
"",
"桑拿按摩",
"前台贵重物品保险柜",
"健身房",
"室内游泳池",
"SPA",
"美容美发室",
"医务室",
"擦鞋服务",
"桌球室",
"免费赠送矿泉水",
"免费赠送地图",
"棋牌室",
"",
"免费赠送报纸",
"",
"收费停车场",
"",
"室外游泳池",
"免费洗漱用品",
"收费洗漱用品",
"浴缸",
"免费传真服务",
"茶室",
"西餐厅",
"大堂吧",
"会议厅",
"卡拉OK厅",
"保龄球馆",
"日式餐厅",
"意大利餐厅",
"高尔夫球练习场",
"足浴",
"直升飞机停机场",
"足球场",
"高尔夫球场",
"电子游戏机室",
"篮球场",
"残疾人客房",
"多种规格电源插座",
"雨伞",
"邮政服务",
"行李存放服务",
"水上运动",
"沙滩排球",
"日光浴场",
"24小时热水",
"客房WIFI",
"公共区WIFIWIFI"
]





module.exports = obj;



// WEBPACK FOOTER //
// ./src/common/equitment.js